import { useState } from 'react';
import integrationService from '../services/integrationService';

const useIntegration = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const connectToExternalSystem = async (projectId, integrationType, configuration) => {
    try {
      setLoading(true);
      setError(null);
      const integration = await integrationService.connectToExternalSystem(projectId, integrationType, configuration);
      return integration;
    } catch (err) {
      setError(err.message || 'Failed to connect to external system');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const getProjectIntegrations = async (projectId) => {
    try {
      setLoading(true);
      setError(null);
      const integrations = await integrationService.getProjectIntegrations(projectId);
      return integrations;
    } catch (err) {
      setError(err.message || 'Failed to fetch integrations');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const syncFeatures = async (integrationId, features) => {
    try {
      setLoading(true);
      setError(null);
      const result = await integrationService.syncFeatures(integrationId, features);
      return result;
    } catch (err) {
      setError(err.message || 'Failed to sync features');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const syncUserStories = async (integrationId, featureId, userStories) => {
    try {
      setLoading(true);
      setError(null);
      const result = await integrationService.syncUserStories(integrationId, featureId, userStories);
      return result;
    } catch (err) {
      setError(err.message || 'Failed to sync user stories');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const disconnectExternalSystem = async (integrationId) => {
    try {
      setLoading(true);
      setError(null);
      await integrationService.disconnectExternalSystem(integrationId);
      return true;
    } catch (err) {
      setError(err.message || 'Failed to disconnect from external system');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    connectToExternalSystem,
    getProjectIntegrations,
    syncFeatures,
    syncUserStories,
    disconnectExternalSystem
  };
};

export default useIntegration;